var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "form" },
    [
      _vm.schema.title
        ? _c("h3", [
            _vm._v(_vm._s(_vm.schema.title)),
            _c("small", [_vm._v(_vm._s(_vm.schema.description))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("form-schema-field-collection", {
        attrs: {
          value: _vm.internalValue,
          schema: _vm.schema.properties,
          "required-keys": _vm.schema.required,
          disabled: _vm.disabled
        },
        on: { input: _vm.handleInput }
      }),
      _vm._v(" "),
      !_vm.noSubmit
        ? _c(
            "v-layout",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue-grey", dark: "" },
                  on: { click: _vm.submit }
                },
                [_vm._v("Submit")]
              ),
              _vm._v(" "),
              _c("v-btn", { on: { click: _vm.reset } }, [_vm._v("Reset")])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cea5b35", { render: render, staticRenderFns: staticRenderFns })
  }
}